import React, { useState } from 'react';
import { View, Text } from 'react-native';

import HeaderDefault from '../../components/HeaderDefault';
import Button from '../../components/Button';
import InputDefault from "../../components/Form/InputDefault";

import styles from './styles';

const EmailPix = () => {
    const [email, setEmail] = useState('');

    return (
        <>
            <HeaderDefault title={"E-mail"} />

            <View style={styles.container}>
                <View style={styles.contentInput}>
                    <InputDefault
                        value={email}
                        onValueChange={(value) => setEmail(value)}
                        placeholder={"E-mail"}
                    />
                </View>


                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Valor da transferência:</Text>
                    <Text>XXX,XXX.XXBRL</Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Recebedor:</Text>
                    <Text>Abelardo Bueno da Costa</Text>
                </View>
            </View>

            <Button route={"ConfirmPassword"} text={"CONTINUAR"} titlePage={"Confirmar tranferência"} />
        </>
    );
}

export default EmailPix;